import { CarModelSpecialStrip } from "@/api/generated/BMWInterfaces"
import LinkWithParams from "@/lib/common/LinkWithParams"
import colors from "@/lib/theme/colors"
import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import Image from "next/image"
import Timer from "../CarModel/Timer"

const StyledStrip = styled(LinkWithParams)`
  display: flex;
  width: 100%;
  padding: 16px 24px;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  border-radius: 8px;
  text-decoration: none;
  background: linear-gradient(90deg, ${colors.directAzureLight} 0%, ${colors.directAzurePale} 100%);
  ${(props) => props.theme.breakpoints.down("md")} {
    padding: 17.5px 24px;
    justify-content: center;
  }
`

const StyledContent = styled.div`
  display: flex;
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
`

const StyledTimerStrip = styled.div`
  display: flex;
  width: 100%;
  padding: 20.5px 24px;
  align-items: center;
  justify-content: center;
  gap: 32px;
  border-radius: 8px;
  text-decoration: none;
  background: linear-gradient(90deg, ${colors.directAzureLight} 0%, ${colors.directAzurePale} 100%);
  border: 1px solid ${colors.directAzure};
  ${(props) => props.theme.breakpoints.down("md")} {
    flex-direction: column;
    gap: 8px;
    padding: 11px 16px;
  }
`

const StyledTimerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  ${(props) => props.theme.breakpoints.down("md")} {
    width: 100%;
    justify-content: center;
  }
`

type Props = {
  data: CarModelSpecialStrip
  showBenefitTimer?: boolean
}

export default function BenefitStrip({ data, showBenefitTimer }: Props): React.ReactElement | null {
  if (!data) {
    return null
  }
  if (showBenefitTimer) {
    const now = new Date()
    const duoDate = new Date(data.duoDate)
    if (duoDate > now) {
      return (
        <StyledTimerStrip>
          <StyledContent>
            <Image src="/assets/benefit-stars.svg" alt="" width={24} height={24} />
            <Typography variant="body1" component="span" fontSize={24}>
              {`זמן לסיום ${data.title}`}
            </Typography>
          </StyledContent>
          <StyledTimerWrapper>
            <Timer dueDate={data.duoDate} withUnitLabels />
          </StyledTimerWrapper>
        </StyledTimerStrip>
      )
    }
  }
  return (
    <StyledStrip href={`/benefit/${data.id?.toString()}`} aria-label={`קבלו ${data.title}`}>
      <Image src="/assets/benefit-stars.svg" alt="" width={24} height={24} />
      <Typography variant="body1" component="span" fontSize={24}>
        {data.title}
      </Typography>

      <Image src="/assets/chevron-left-double.svg" alt="" width={16} height={16} />
    </StyledStrip>
  )
}
